import { Box } from "@chakra-ui/react";

const MobileNotSupported = () => {
  return (
    <Box
      m="1rem"
      px="1.5rem"
      py="1.2rem"
      bgColor="brand.backgroundLight"
      borderRadius="1rem"
      textAlign="center"
    >
      <Box fontSize="1.5rem" fontWeight={600} pb="1rem">
        Hi there, welcome to the Stader community :)
      </Box>
      <Box>
        Hedera staking is currently only available on Desktop, please access the
        Dapp on desktop.
      </Box>
    </Box>
  );
};

export default MobileNotSupported;
